import React, { Component } from 'react';
import Sidebar from '../commonAdmin/Sidebar';
import Header from '../commonAdmin/Header';
import Footer from '../commonAdmin/Footer';
import moment from 'moment';
import { Row, Col, Image, Card, Accordion, Button } from 'react-bootstrap';

import profileImg1 from '../../../assets/images/user.png';
import deliverAgentIco1 from '../../../assets/images/deliverAgentIco1.svg';
import deliverAgentIco2 from '../../../assets/images/deliverAgentIco2.svg';
import deliverAgentIco3 from '../../../assets/images/deliverAgentIco3.svg';
import deliverAgentIco4 from '../../../assets/images/deliverAgentIco4.svg';
import idPic from '../../../assets/images/id-pic.svg';
import emptyStar from '../../../assets/images/emptystar.svg';
import halfStar from '../../../assets/images/halfstar.svg';
import fullStar from '../../../assets/images/fullstar.svg';
import Template from '../../../common/helpers/Template';
import Loader from '../../common/Loader';
import delivaApiService from '../../../common/services/apiService';
import {
  getLocalStorage,
  getStatusClassName,
  setLocalStorage,
} from '../../../common/helpers/Utils';
import CopyButton from '../../common/CopyButton';
import CaretDownArrow from '../../../assets/images/CaretDoubleDown.svg';
import Alerts from './Alerts';
import CustomKycModal from '../../common/CustomKycModal';
import validateInput from '../../../common/validations/validateProofs';
import ApprovedChecked from '../../../assets/images/approved.svg';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';

class DeliveryAgentProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      showLoader: false,
      profile_detail: {},
      totalOrder: '',
      trip: '',
      toBeDeliver: '',
      submittedBid: '',
      readyForPickup: '',
      openBid: '',
      cancelledOrder: '',
      cancelledBid: '',
      showKycApproveModal: false,
      errors: {},
    };
    this.handleToggleIcon = this.handleToggleIcon.bind(this);
  }

  handleToggleIcon() {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen, // Toggle the isOpen state
    }));
  }

  componentDidMount() {
    if (this.props && this.props.location?.state?.item) {
      this.deliveryAgentProfile(this.props.location?.state?.item.userId);
      this.deliveryAgentProfileCount(this.props.location?.state?.item.userId);
      setLocalStorage('DAid', this.props.location?.state?.item.userId);
    } else {
      this.deliveryAgentProfile(getLocalStorage('DAid'));
      this.deliveryAgentProfileCount(getLocalStorage('DAid'));
    }
  }
  deliveryAgentOrders = () => {
    // if(!item.blocked){
    this.props.history.push('/deliveryagentorder', getLocalStorage('DAid'));
    // }
  };
  deliveryAgentBids = (path) => {
    // if(!item.blocked){
    this.props.history.push(path + '/' + getLocalStorage('DAid'));
    // }
  };
  approveDA = (userId, name) => {
    console.log('safsdg');
    const validation = validateInput(this.state, 'kycRemark');
    if (validation.isValid) {
      this.setState({
        showLoader: true,
        daName: name,
        userId: userId,
        errors: {},
      });
      const approveDaPayload = {
        userId: userId,
        kycApprovedByAdmin: true,
        verificationDetailsByAdmin: this.state.kycRemark,
      };
      delivaApiService('approveDA', approveDaPayload)
        .then((response) => {
          this.setState({
            showLoader: false,
            successModal: true,
            showKycApproveModal: false,
          });
          if (response.data.status == 200) {
            this.getDeliveryAgentProfile(userId);
          }
        })
        .catch((error) => {
          this.setState({
            showLoader: false,
          });
        });
    } else {
      this.setState({
        errors: validation.errors,
      });
    }
  };
  deliveryAgentProfile = (id) => {
    this.setState({
      showLoader: true,
    });
    delivaApiService('deliveryAgentprofile', {
      daId: id,
      logInUserId: getLocalStorage('id'),
    })
      .then((response) => {
        this.setState({ showLoader: false });
        if (response.data.status == 200) {
          this.setState({ profile_detail: response.data.resourceData });
        }
      })
      .catch((error) => {
        this.setState({
          showLoader: false,
        });
      });
  };
  openKycApproveModel = () => {
    this.setState({
      showKycApproveModal: true,
    });
  };

  deliveryAgentProfileCount = (id) => {
    this.setState({
      showLoader: true,
    });
    delivaApiService('deliveryAgentprofileCount', {
      daId: id,
    })
      .then((response) => {
        this.setState({ showLoader: false });
        if (response.data.status == 200) {
          this.setState({
            totalOrder: response.data.resourceData.totalOrder,
            trip: response.data.resourceData.trip,
            toBeDeliver: response.data.resourceData.toBeDeliver,
            submittedBid: response.data.resourceData.submittedBid,
            readyForPickup: response.data.resourceData.readyForPickup,
            openBid: response.data.resourceData.openBid,
            cancelledOrder: response.data.resourceData.cancelledOrder,
            cancelledBid: response.data.resourceData.cancelledBid,
          });
        }
      })
      .catch((error) => {
        this.setState({
          showLoader: false,
        });
      });
  };

  handleRemarksChange = (e) => {
    const { value } = e.target;

    this.setState({ kycRemark: value }, () => {
      this.updateErrors('kycRemark');
    });
  };

  updateErrors = (fieldName) => {
    const { errors } = validateInput(this.state, fieldName);

    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        [`${fieldName}Error`]: errors[`${fieldName}Error`] || '',
      },
    }));
  };

  getKycApprovalStatusClass = (isApproved) => {
    if (isApproved === true) {
      return 'textGreen';
    } else if (isApproved === false) {
      return 'textRed';
    } else {
      return '';
    }
  };
  getKycAlertVariant = () => {
    const status =
      this.state.profile_detail?.userKycDetailsResponse
        ?.verificationDojahStatus !== null
        ? this.state.profile_detail.userKycDetailsResponse
            .verificationDojahStatus
        : this.state.profile_detail?.verificationAdminStatus;

    if (this.state.profile_detail?.userKycDetailsResponse.kycApprovedByAdmin) {
      return 'success';
    }
    console.log('status', status);
    switch (status) {
      case 'Completed':
        return 'success';
      case 'Failed':
        return 'danger';
      case 'Pending':
        return 'warning';
      case 'Ongoing':
        return 'warning';

      case 'Rejected':
        return 'danger';
      default:
        return 'default';
    }
  };

  render() {
    let drawRating = [1, 2, 3, 4, 5];
    const {
      isOpen,
      profile_detail,
      totalOrder,
      trip,
      toBeDeliver,
      submittedBid,
      readyForPickup,
      openBid,
      cancelledOrder,
      cancelledBid,
    } = this.state;

    return (
      <div className="page__wrapper h-100">
        <Header {...this.props} />

        <div className="mainContainer CustomerTable">
          <Row noGutters className="h-100">
            <Sidebar {...this.props} />
            <Col md={9} lg={10} className="boxTyp3">
              <div className="container-fluid">
                <div className="content-wrapper">
                  <Row noGutters className="mb-3">
                    <Col md={6} lg={8} className="">
                      <h3 className="font-weight-normal fs22 mb-2 color-33">
                        Delivery Partner's Profile{' '}
                      </h3>
                      <h5 className="font-weight-normal fs18 mb-0 color-head text-capitalize">
                        <span
                          onClick={() =>
                            this.props.history.push('/deliveryPartnerList')
                          }
                          className="pointer text-capitalize"
                        >
                          {' '}
                          Delivery Partners{' '}
                        </span>
                        <span className="icon-next mx-2 Fs12"></span> Delivery
                        Partner's profile{' '}
                      </h5>
                    </Col>
                  </Row>
                  <div className="cust-details-wrap border-0 mb-4">
                    <Row noGutters className="align-items-center">
                      <Col md={6} lg={4} className="align-items-center">
                        <div className="d-flex align-items-center gap-3">
                          <Image
                            src={
                              profile_detail.profileImageUrl
                                ? profile_detail.profileImageUrl
                                : profileImg1
                            }
                            className="img-fluid max-width-sm rounded-circle"
                          />
                          <div className="d-flex h-100 align-items-center">
                            <div className="pr-wrap">
                              <h4>
                                {profile_detail.name ? profile_detail.name : ''}
                              </h4>

                              <div className="ratings my-2">
                                {drawRating.map((item, i) => {
                                  const ratingFloor = Math.floor(
                                    profile_detail.daRating
                                  );
                                  const hasHalfStar =
                                    profile_detail.daRating - ratingFloor >=
                                    0.5;

                                  if (i < ratingFloor) {
                                    return (
                                      <span key={i}>
                                        <Image
                                          src={fullStar}
                                          className="img-fluid"
                                        />
                                      </span>
                                    );
                                  } else if (i === ratingFloor && hasHalfStar) {
                                    return (
                                      <span key={i}>
                                        <Image
                                          src={halfStar}
                                          className="img-fluid"
                                        />
                                      </span>
                                    );
                                  } else {
                                    return (
                                      <span key={i}>
                                        <Image
                                          src={emptyStar}
                                          className="img-fluid"
                                        />
                                      </span>
                                    );
                                  }
                                })}
                                <span>{profile_detail?.daRating}</span>
                              </div>

                              <p className="color-grey">
                                ID: #
                                {profile_detail.userId
                                  ? profile_detail.userId
                                  : ''}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col md={4} lg={4} className="">
                        <div className="d-flex h-100 align-items-center bor-left pl-3">
                          <ul className="pl-2 detail-list mb-0 color-grey">
                            <li>
                              <span className="icon-phone"></span>+
                              {profile_detail.countryCode}{' '}
                              {profile_detail.mobile}
                            </li>
                            <li>
                              <span className="icon-email"></span>
                              {profile_detail.email || '--'}
                            </li>
                            <li className="d-flex">
                              <span className="icon-pin map-ico-user"></span>
                              {profile_detail.address}
                            </li>
                          </ul>
                        </div>
                      </Col>
                      <Col md={4} lg={4} className="">
                        <div className="d-flex h-100 align-items-center bor-left pl-3">
                          <div className="pl-2 detail-list mb-0 color-grey">
                            <span className="pl-2 detail-list  color-grey">
                              Joining date
                            </span>
                            <p className="pl-2 detail-list mb-3 color-grey ">
                              {moment(profile_detail.joiningDate)
                                .utc()
                                .format('DD MMM YYYY')}
                            </p>

                            <span className="pl-2 detail-list mb-0 color-grey">
                              Last login
                            </span>
                            <p className="pl-2 detail-list mb-3 color-grey">
                              {profile_detail.lastLogin}
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <Row className="row my-4">
                    <Col md={6}>
                      <div className="dash-b-wrapper p-dec">
                        <div className="row">
                          <div className="col-md-2 pl-0">
                            <Image
                              src={deliverAgentIco1}
                              className="img-fluid"
                            />
                          </div>
                          <div
                            className="col-md-6 p-0 pointer"
                            onClick={() =>
                              this.deliveryAgentBids(
                                '/deliveryPartnerOrders/totalorders'
                              )
                            }
                          >
                            <h1 className="dark-grey t-value mb-0">
                              {totalOrder}
                            </h1>
                            <h4 className="color-head font-weight-normal font-25 mb-0 mt-2">
                              {' '}
                              {Template.TOTALORDERS}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="dash-b-wrapper p-dec">
                        <div className="row">
                          <div className="col-md-2 pl-0">
                            <Image
                              src={deliverAgentIco3}
                              className="img-fluid"
                            />
                          </div>
                          <div
                            className="col-md-6 p-0 pointer"
                            onClick={() =>
                              this.deliveryAgentBids(
                                '/deliveryPartner/totalbids'
                              )
                            }
                          >
                            <h1 className="dark-grey t-value mb-0">
                              {submittedBid}
                            </h1>
                            <h4 className="color-head font-weight-normal font-25 mb-0 mt-2">
                              {' '}
                              Total Submitted Bids{' '}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="row my-4">
                    <Col md={3} className="mb-4">
                      <div className="colored-wrap orange-box">
                        <h4 className="color-grey font-weight-normal font-35 text-capitalize w-100">
                          Ready To Pickup
                        </h4>
                        <h1 className="dark-grey t-value font-70 mb-0 opacity-dec d-flex align-self-end">
                          {readyForPickup}
                        </h1>
                      </div>
                    </Col>
                    <Col md={3} className="mb-4">
                      <div className="colored-wrap blue-box">
                        <h4 className="color-grey font-weight-normal font-35 text-capitalize w-100">
                          To Deliver
                        </h4>
                        <h1 className="dark-grey t-value font-70 mb-0 opacity-dec d-flex align-self-end">
                          {toBeDeliver}
                        </h1>
                      </div>
                    </Col>
                    <Col md={3} className="mb-4">
                      <div className="colored-wrap purple-box">
                        <h4 className="color-grey font-weight-normal font-35 text-capitalize w-100">
                          Cancelled Bids
                        </h4>
                        <h1 className="dark-grey t-value font-70 mb-0 opacity-dec d-flex align-self-end">
                          {cancelledBid}
                        </h1>
                      </div>
                    </Col>
                    <Col md={3} className="mb-4">
                      <div className="colored-wrap yellow-box">
                        <h4 className="color-grey font-weight-normal font-35 text-capitalize w-100">
                          Cancelled Orders
                        </h4>
                        <h1 className="dark-grey t-value font-70 mb-0 opacity-dec d-flex align-self-end">
                          {cancelledOrder}
                        </h1>
                      </div>
                    </Col>
                  </Row>
                  {profile_detail?.userKycDetailsResponse
                    ?.verificationMessage && (
                    <Alerts
                      variant={this.getKycAlertVariant()}
                      content={
                        this.state.profile_detail?.userKycDetailsResponse
                          ?.verificationMessage || ''
                      }
                      className="mb-3"
                    />
                  )}
                  <div className="details-wrap mb-4">
                    <Row>
                      <Col md={6} lg={6}>
                        <h5 className="px-4">KYC Documents</h5>

                        <hr className="mb-3" />
                      </Col>

                      <Col md={6} lg={6}>
                        <div className="textGreen px-4 mt-md-2 d-flex justify-content-end">
                          {
                            profile_detail?.userKycDetailsResponse
                              ?.verificationTag
                          }
                        </div>
                        <hr className="mt-3" />
                      </Col>
                    </Row>

                    <div className="kyc-document px-4">
                      <Row>
                        <Col lg={4}>
                          <Card className="card-link mb-4">
                            <Card.Body className="p-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <h5 className="fs14">ID url of front image</h5>
                                <CopyButton
                                  textToCopy={
                                    profile_detail?.userKycDetailsResponse
                                      ?.idImageUrl
                                  }
                                />
                              </div>
                              <a
                                href={
                                  profile_detail?.userKycDetailsResponse
                                    ?.idImageUrl
                                }
                              >
                                {
                                  profile_detail?.userKycDetailsResponse
                                    ?.idImageUrl
                                }
                              </a>
                            </Card.Body>
                          </Card>
                          <Card className="card-id mb-4">
                            <Card.Body>
                              <Image
                                className="img-fluid"
                                src={
                                  profile_detail?.userKycDetailsResponse
                                    ?.idImageUrl
                                }
                              />
                            </Card.Body>
                          </Card>
                        </Col>
                        <Col lg={4}>
                          <Card className="card-link mb-4">
                            <Card.Body className="p-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <h5 className="fs14">ID url of back image</h5>
                                <CopyButton
                                  textToCopy={
                                    profile_detail?.userKycDetailsResponse
                                      ?.backImageUrl
                                  }
                                />
                              </div>
                              <a
                                href={
                                  profile_detail?.userKycDetailsResponse
                                    ?.backImageUrl
                                }
                              >
                                {
                                  profile_detail?.userKycDetailsResponse
                                    ?.backImageUrl
                                }
                              </a>
                            </Card.Body>
                          </Card>
                          <Card className="card-id mb-4">
                            <Card.Body>
                              <Image
                                className="img-fluid"
                                src={
                                  profile_detail?.userKycDetailsResponse
                                    ?.backImageUrl
                                }
                              />
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                    <div className="kyc-data px-4">
                      <Row>
                        <Col md={6} lg={3} className="mb-4">
                          <div className="pr-wrap">
                            <label className="font-weight-normal color-grey fs18">
                              Expiry Date
                            </label>
                            <h5 className="fs18 font-weight-normal">
                              {profile_detail?.userKycDetailsResponse
                                ?.expiryDate
                                ? moment(
                                    profile_detail?.userKycDetailsResponse
                                      ?.expiryDate
                                  )
                                    // .utc()
                                    .format('DD MMM YYYY')
                                : '--'}
                            </h5>
                          </div>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <div className="pr-wrap">
                            <label className="font-weight-normal color-grey fs18">
                              Country
                            </label>
                            <h5 className="fs18 font-weight-normal">
                              {' '}
                              {profile_detail?.userKycDetailsResponse
                                ?.country || '--'}
                            </h5>
                          </div>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <div className="pr-wrap">
                            <label className="font-weight-normal color-grey fs18">
                              Date of Birth
                            </label>
                            <h5 className="fs18 font-weight-normal">
                              {profile_detail?.userKycDetailsResponse
                                ?.dateOfBirth
                                ? moment(
                                    profile_detail.userKycDetailsResponse
                                      .dateOfBirth
                                  )
                                    // .utc()
                                    .format('DD MMM YYYY')
                                : '--'}
                            </h5>
                          </div>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <div className="pr-wrap">
                            <label className="font-weight-normal color-grey fs18">
                              Email
                            </label>
                            <h5 className="fs18 font-weight-normal">
                              {profile_detail?.userKycDetailsResponse?.email ||
                                '--'}
                            </h5>
                          </div>
                        </Col>
                        {profile_detail.documentationType ==
                          'DOJAH_DOCUMENTATION' && (
                          <Col md={6} lg={3} className="mb-4 mb-md-0">
                            <div className="pr-wrap">
                              <label className="font-weight-normal color-grey fs18">
                                Verified by Dojha
                              </label>
                              <h5
                                className={`fs18 font-weight-normal ${getStatusClassName(
                                  profile_detail?.userKycDetailsResponse
                                    ?.verificationDojahStatus
                                )}`}
                              >
                                {profile_detail?.userKycDetailsResponse
                                  ?.verificationDojahStatus || '--'}
                              </h5>
                            </div>
                          </Col>
                        )}
                        {profile_detail?.userKycDetailsResponse?.expiryNote && (
                          <Col md={6} lg={3} className="mb-0">
                            <div className="pr-wrap">
                              <label className="font-weight-normal color-grey fs18">
                                Note
                              </label>
                              <h5 className="fs18 font-weight-normal">
                                {
                                  profile_detail?.userKycDetailsResponse
                                    ?.expiryNote
                                }
                              </h5>
                            </div>
                          </Col>
                        )}

                        <Col md={6} lg={3} className="mb-0">
                          <div className="pr-wrap">
                            <label className="font-weight-normal color-grey fs18">
                              Identification Number
                            </label>
                            <h5 className="fs18 font-weight-normal">
                              {profile_detail?.userKycDetailsResponse
                                ?.idNumber || '--'}
                            </h5>
                          </div>
                        </Col>
                        {this.state.profile_detail.userKycDetailsResponse
                          ?.kycApprovedByAdmin && (
                          <Col md={6} lg={3} className="mb-0">
                            <div className="pr-wrap">
                              <label className="font-weight-normal color-grey fs18">
                                Verified By Admin
                              </label>
                              <h5
                                className={`fs18 font-weight-normal ${this.getKycApprovalStatusClass(
                                  this.state.profile_detail
                                    ?.userKycDetailsResponse?.kycApprovedByAdmin
                                )}`}
                              >
                                {
                                  this.state.profile_detail
                                    ?.userKycDetailsResponse
                                    ?.verificationAdminStatus
                                }
                              </h5>
                            </div>
                          </Col>
                        )}
                      </Row>
                      {profile_detail.documentationType ===
                        'DOJAH_DOCUMENTATION' &&
                        profile_detail.userKycDetailsResponse
                          .additionalNotes && (
                          <div className="mt-4">
                            <Accordion
                              defaultActiveKey="0"
                              activeKey={isOpen ? '0' : null}
                              className="accType2 mb-4 "
                              onSelect={this.handleToggleIcon}
                            >
                              <Card className="bg-lightgray border-0">
                                <Card.Header className="px-3 py-2 border-0 bg-transparent">
                                  <Accordion.Toggle
                                    as={Button}
                                    variant="link"
                                    eventKey="0"
                                    className="w-100 text-left color-black p-0 font-weight-bold text-decoration-none"
                                  >
                                    Additional information{' '}
                                    <Image
                                      src={CaretDownArrow}
                                      style={{ maxHeight: '16px' }}
                                      className={`img-fluid user-block-img float-right rotate-icon ${
                                        isOpen ? 'rotated' : ''
                                      }`}
                                    />
                                  </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="0">
                                  <Card.Body className="px-3 py-2">
                                    {profile_detail.documentationType ===
                                      'DOJAH_DOCUMENTATION' &&
                                      profile_detail.userKycDetailsResponse
                                        .additionalNotes}
                                  </Card.Body>
                                </Accordion.Collapse>
                              </Card>
                            </Accordion>
                          </div>
                        )}
                    </div>
                  </div>
                  <div
                    className={`details-wrap mb-4 ${profile_detail?.bankingDetails?.bankDetailsApprovedByAdmin}pointer`}
                  >
                    <Row noGutters>
                      <Col md={12} lg={12} className="">
                        <h5 className="px-4">Banking Details</h5>
                        <hr />
                      </Col>
                    </Row>
                    <Row className="px-4 gy-2">
                      <Col md={6} lg={4} className="">
                        <div className="pr-wrap">
                          <h5 className="font-weight-normal color-grey fs18">
                            Full Name
                          </h5>
                          <h5 className="fs18 font-weight-normal">
                            {profile_detail?.bankingDetails?.fullName}
                          </h5>
                        </div>
                      </Col>
                      <Col md={6} lg={4} className="">
                        <div className="">
                          <h5 className="font-weight-normal color-grey fs18">
                            Account Number
                          </h5>
                          <h5 className="fs18 font-weight-normal">
                            {profile_detail?.bankingDetails?.accountNumber}
                          </h5>
                        </div>
                      </Col>
                      <Col md={6} lg={4} className="">
                        <div className="">
                          <h5 className="font-weight-normal color-grey fs18">
                            Bank
                          </h5>
                          <h5 className="fs18 font-weight-normal">
                            {profile_detail?.bankingDetails?.bankName}
                          </h5>
                        </div>
                      </Col>

                      {profile_detail?.bankingDetails
                        ?.bankDetailsApprovedByAdmin && (
                        <Col md={6} lg={3}>
                          <div className="">
                            <h5 className="font-weight-normal color-grey fs18">
                              Status
                            </h5>
                            <h5
                              className={`fs18 font-weight-normal ${
                                profile_detail?.bankingDetails?.status ===
                                'Pending'
                                  ? 'textOrange'
                                  : profile_detail?.bankingDetails?.status ===
                                    'Verified'
                                  ? 'textGreen'
                                  : profile_detail?.bankingDetails?.status ===
                                    'Rejected'
                                  ? 'textRed'
                                  : ''
                              }`}
                            >
                              {' '}
                              {profile_detail?.bankingDetails?.status}
                            </h5>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <hr />
                  </div>
                </div>

                {this.state.showKycApproveModal && (
                  <CustomKycModal
                    show={this.state.showKycApproveModal}
                    onHide={() => this.setState({ showKycApproveModal: false })}
                    icon={ApprovedChecked}
                    iconClass="img-fluid user-block-img"
                    heading="Are you sure to approve this request?"
                    headingClass="color-green mt-3 fs-22 nowrap"
                    text="Please write the reason for approval"
                    buttons={[
                      {
                        label: 'No',
                        className: 'cancel-btn mr-4 min-w-80',
                        onClick: () =>
                          this.setState({
                            showKycApproveModal: false,
                            errors: {},
                          }),
                      },
                      {
                        label: 'Yes',
                        className: 'b1-btn min-w-80',
                        onClick: () =>
                          this.approveDA(
                            profile_detail.userId,
                            profile_detail.name
                          ),
                        disabled: this.state.showLoader,
                      },
                    ]}
                  >
                    <Form.Group controlId="exampleForm.ControlTextarea1">
                      <Form.Control
                        as="textarea"
                        rows="3"
                        name="kycApproveRemark"
                        onChange={this.handleRemarksChange}
                        maxLength="100"
                      />
                      <span className="min-char d-block">Max 100 chars</span>
                      {/* 
              {errors.kycRemarkError && (
                <span className="text-danger">{errors.kycRemarkError}</span>
              )} */}
                    </Form.Group>
                  </CustomKycModal>
                )}
              </div>
              <Footer {...this.props} />
            </Col>
          </Row>
        </div>
        <Loader showLoader={this.state.showLoader} />
      </div>
    );
  }
}
export default DeliveryAgentProfile;
